export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/1a9a4500-7279-4f03-ae00-42acc8365d9b/6faaf775-79cf-4bf6-a10f-57d421b38cd4_cropped-AIR-TEK-logo-.jpg?v=f784fa9615b2f2704d57680a9749563d"
                alt="Air-Tek NC Logo"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Your local HVAC and Electrical company for both residential and commercial service. Locally owned and trusted across Southern NC.
            </p>
            <a
              href="tel:9193489399"
              className="flex items-center gap-2 text-[#0066aa] font-bold text-lg cursor-pointer hover:text-[#004d80] transition-colors duration-200 mb-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-[#0066aa]" />
              </div>
              (919) 348-9399
            </a>
            <a
              href="mailto:airteknc@gmail.com"
              className="flex items-center gap-2 text-gray-500 text-sm cursor-pointer hover:text-[#0066aa] transition-colors duration-200 mb-3"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line" />
              </div>
              airteknc@gmail.com
            </a>
            <p className="text-gray-400 text-xs">653 Connors Cove, Hope Mills, NC 28348</p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://www.facebook.com/airteknc/"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-[#0066aa]/10 text-gray-500 hover:text-[#0066aa] transition-all duration-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-base" />
              </a>
              <a
                href="https://www.google.com/search?q=Airtek+HVAC+and+Electrical+Hope+Mills%2C+NC"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-[#0066aa]/10 text-gray-500 hover:text-[#0066aa] transition-all duration-200 cursor-pointer"
              >
                <i className="ri-google-fill text-base" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#0a1628] font-bold text-sm mb-5 uppercase tracking-wider">Services</h4>
            <ul className="space-y-2.5">
              {[
                'Air Conditioning',
                'Heating Systems',
                'HVAC Maintenance',
                'Indoor Air Quality',
                'Commercial HVAC',
              ].map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    onClick={(e) => { e.preventDefault(); handleNav('#services'); }}
                    className="text-gray-500 hover:text-[#0066aa] text-sm transition-colors duration-200 cursor-pointer flex items-center gap-2"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-[#0066aa] text-xs" />
                    </div>
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-[#0a1628] font-bold text-sm mb-5 uppercase tracking-wider">Service Areas</h4>
            <div className="flex flex-wrap gap-2">
              {[
                'Dunn', 'Spring Lake', 'Fayetteville', 'Hope Mills', 'Raeford',
                'Parkton', 'Lumberton', 'Elizabethtown', 'Red Springs', 'Saint Pauls',
              ].map((city) => (
                <span key={city} className="text-gray-600 text-xs bg-gray-100 px-2.5 py-1 rounded-md">
                  {city}
                </span>
              ))}
            </div>
            <p className="text-gray-400 text-xs mt-3">And all surrounding areas!</p>
            <div className="mt-5 bg-[#0066aa]/8 border border-[#0066aa]/20 rounded-lg p-4">
              <p className="text-gray-600 text-xs leading-relaxed">
                <span className="text-[#0066aa] font-semibold">Available 24/7</span> — Call us anytime for emergency HVAC service across Southern NC.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-xs">
            &copy; {new Date().getFullYear()} Air-Tek NC. All rights reserved. Licensed &amp; Insured HVAC Contractor — North Carolina.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-400 hover:text-gray-600 text-xs transition-colors duration-200 cursor-pointer">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
